const DRAFT_PREFIX =
    'festfriends:message-draft:';

const DRAFT_MAX_AGE_MS =
    7 * 24 * 60 * 60 * 1000;

const parseInboxDraft = (
    rawDraft
) => {
    if (! rawDraft) {
        return null;
    }

    try {
        const draft =
            JSON.parse(rawDraft);

        if (
            typeof draft?.body
            !== 'string'
            || typeof draft?.savedAt
            !== 'number'
            || draft.body.trim() === ''
        ) {
            return null;
        }

        if (
            Date.now()
            - draft.savedAt
            > DRAFT_MAX_AGE_MS
        ) {
            return null;
        }

        return draft;
    } catch {
        return null;
    }
};

const relativeDraftTime = (
    savedAt
) => {
    const seconds =
        Math.max(
            0,
            Math.floor(
                (
                    Date.now()
                    - savedAt
                )
                / 1000
            )
        );

    if (seconds < 60) {
        return 'Draft saved just now';
    }

    const minutes =
        Math.floor(
            seconds / 60
        );

    if (minutes < 60) {
        return `Draft saved ${minutes} ${minutes === 1 ? 'minute' : 'minutes'} ago`;
    }

    const hours =
        Math.floor(
            minutes / 60
        );

    if (hours < 24) {
        return `Draft saved ${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
    }

    const days =
        Math.floor(
            hours / 24
        );

    return `Draft saved ${days} ${days === 1 ? 'day' : 'days'} ago`;
};

const decorateConversationDrafts = () => {
    const cards =
        document.querySelectorAll(
            '[data-conversation-card][data-conversation-id]'
        );

    if (cards.length === 0) {
        return;
    }

    cards.forEach(
        (card) => {
            const conversationId =
                card.dataset
                    .conversationId;

            if (! conversationId) {
                return;
            }

            const storageKey =
                `${DRAFT_PREFIX}${conversationId}`;

            const rawDraft =
                localStorage.getItem(
                    storageKey
                );

            const draft =
                parseInboxDraft(
                    rawDraft
                );

            if (
                rawDraft
                && ! draft
            ) {
                localStorage.removeItem(
                    storageKey
                );
            }

            const badge =
                card.querySelector(
                    '[data-conversation-draft-badge]'
                );

            const draftPreview =
                card.querySelector(
                    '[data-conversation-draft-preview]'
                );

            const draftText =
                card.querySelector(
                    '[data-conversation-draft-text]'
                );

            const draftTime =
                card.querySelector(
                    '[data-conversation-draft-time]'
                );

            const lastPreview =
                card.querySelector(
                    '[data-conversation-last-preview]'
                );

            if (! draft) {
                badge
                    ?.classList
                    .add('hidden');

                draftPreview
                    ?.classList
                    .add('hidden');

                draftTime
                    ?.classList
                    .add('hidden');

                lastPreview
                    ?.classList
                    .remove('hidden');

                return;
            }

            badge
                ?.classList
                .remove('hidden');

            if (draftText) {
                draftText.textContent =
                    draft.body
                        .replace(
                            /\s+/g,
                            ' '
                        )
                        .trim();
            }

            draftPreview
                ?.classList
                .remove('hidden');

            if (draftTime) {
                draftTime.textContent =
                    relativeDraftTime(
                        draft.savedAt
                    );

                draftTime.classList.remove(
                    'hidden'
                );
            }

            /*
             * Prioritize the unsent draft over the last server message so
             * users can immediately see the unfinished thought they left.
             */
            lastPreview
                ?.classList
                .add('hidden');
        }
    );
};

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        decorateConversationDrafts
    );
} else {
    decorateConversationDrafts();
}

window.addEventListener(
    'storage',
    (event) => {
        if (
            event.key
            ?.startsWith(
                DRAFT_PREFIX
            )
        ) {
            decorateConversationDrafts();
        }
    }
);
